export default "__VITE_ASSET__ac12900c__"